import React from "react";
import AuthLayout from "../layouts/auth";
import PaymentMethodsForm from "../components/payment-method-form";
import { useTranslation } from "../contexts/I18nProvider";

function AddPaymentMethod() {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <PaymentMethodsForm />
    </AuthLayout>
  );
}

export default AddPaymentMethod;
